export default __webpack_public_path__ + "static/media/tal.2b31e5a9.svg";